import { APPOINTMENT_REQUEST_PAST, APPOINTMENT_REQUEST_PAST_ERROR, APPOINTMENT_REQUEST_PAST_SUCCESS, APPOINTMENT_REQUEST_TODAY, APPOINTMENT_REQUEST_TODAY_ERROR, APPOINTMENT_REQUEST_TODAY_SUCCESS, APPOINTMENT_REQUEST_UPCOMING, APPOINTMENT_REQUEST_UPCOMING_ERROR, APPOINTMENT_REQUEST_UPCOMING_SUCCESS } from './Constant';

// userReducer.js
const initialState = {
    loading: false,
    error: null,
};
  
export const appointmentsListReducer = (state = initialState, action) => {
    switch (action.type) {
    case APPOINTMENT_REQUEST_TODAY:
        return { ...state, loading: true };
    case APPOINTMENT_REQUEST_TODAY_SUCCESS:        
        return { ...state, todayAppointemts : action.payload, loading: false };
    case APPOINTMENT_REQUEST_TODAY_ERROR:
        return { ...state, loading: false };
    case APPOINTMENT_REQUEST_UPCOMING:
        return { ...state, loading: true };
    case APPOINTMENT_REQUEST_UPCOMING_SUCCESS:        
        return { ...state, upcomingAppointemts : action.payload, loading: false };
    case APPOINTMENT_REQUEST_UPCOMING_ERROR:
        return { ...state, loading: false };    
    case APPOINTMENT_REQUEST_PAST:
        return { ...state, loading: true };
    case APPOINTMENT_REQUEST_PAST_SUCCESS:        
        return { ...state, pastAppointemts : action.payload, loading: false };
    case APPOINTMENT_REQUEST_PAST_ERROR:
        return { ...state, loading: false };
    default:
        return state;
    }
};
  